import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { ConfigService } from '../../shared/services/config.service';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss'],
})
export class ContentLayoutComponent implements OnInit, AfterViewInit {
  public config: any = {};
  direction: 'ltr';
  @ViewChild('content-wrapper', { static: false }) wrapper: ElementRef;

  constructor(
    private _configService: ConfigService,
    @Inject(DOCUMENT) private _document: Document,
    private _renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.config = this._configService.templateConf;
  }

  ngAfterViewInit(): void {
    setTimeout((): void => {
      if (this.config.layout.dir) {
        this.direction = this.config.layout.dir;
      }

      if (this.config.layout.variant === 'Dark') {
        this._renderer.addClass(this._document.body, 'layout-dark');
      } else if (this.config.layout.variant === 'Transparent') {
        this._renderer.addClass(this._document.body, 'layout-dark');
        this._renderer.addClass(this._document.body, 'layout-transparent');

        if (this.config.layout.sidebar.backgroundColor) {
          this._renderer.addClass(
            this._document.body,
            this.config.layout.sidebar.backgroundColor,
          );
        } else {
          this._renderer.addClass(this._document.body, 'bg-glass-1');
        }
      }
    }, 0);
  }
}
